import { parseRuntime, ruleEngineRequest } from './impl-helper';

export const getAbtFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);
    const factInfo = current.node.data.factInfo;
    const eid = factInfo.props.eid || '';

    //没有eid的时候，直接返回false
    if (!eid) {
        return false;
    }

    const { version } = await ruleEngineRequest('abtest-container', 'join', {
        eid
    }, variable, {
        method: 'post',
        reqOpt: { group: null }
    });

    return current.port.id === version;
};
